module.exports = __webpack_public_path__ + "img/mot-finder-illustration.e06b6af.webp";